import { render, staticRenderFns } from "./MenuCadastro.vue?vue&type=template&id=53ee84f8&scoped=true"
import script from "./MenuCadastro.vue?vue&type=script&lang=js"
export * from "./MenuCadastro.vue?vue&type=script&lang=js"
import style0 from "./MenuCadastro.vue?vue&type=style&index=0&id=53ee84f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee84f8",
  null
  
)

export default component.exports